export const save = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error("Failed to save to localStorage", e);
  }
};

export const retrieve = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (!value) return null;

    // // Handle legacy data that might be stored as "[object Object]"
    // if (value === "[object Object]") {
    //     console.warn(`Legacy data detected for key "${key}". Consider clearing this data.`);
    //     return null;
    // }

    try {
      return JSON.parse(value);
    } catch {
      // If JSON.parse fails, return the raw string value
      // This handles cases where data was stored as plain strings
      return value;
    }
  } catch (e) {
    console.error("Failed to retrieve from localStorage", e);
    return null;
  }
};

export const remove = (key) => {
  try {
    if (retrieve(key)) {
      localStorage.removeItem(key);
    }
  } catch (e) {
    console.error("Failed to remove from localStorage", e);
  }
};
